// @ts-strict-ignore
import * as React from 'react';
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import Button from 'antd/lib/button';
import { SortAscendingOutlined } from '@ant-design/icons';
import { runwayColors } from '../styles/globalStyles';

export interface SortOption<T> {
    sortType: T;
    icon?: React.ReactNode;
    text: string;
}

export interface SortTablePopoverProps<T> {
    sortOptions: SortOption<T>[];
    onSelectSort: (selectedSortType: T) => void;
    selectedSortType: T;
}

export function SortTableButton<T extends string>({
    onSelectSort,
    sortOptions,
    selectedSortType,
}: SortTablePopoverProps<T>) {
    const overlayMenu = () => {
        return (
            <Menu activeKey={selectedSortType}>
                {sortOptions.map(({ sortType, icon, text }) => (
                    <Menu.Item
                        key={sortType}
                        icon={icon}
                        onClick={() => {
                            onSelectSort(sortType);
                        }}
                    >
                        {text}
                    </Menu.Item>
                ))}
            </Menu>
        );
    };

    const selectedSortOption = sortOptions.find(({ sortType }) => sortType === selectedSortType);

    return (
        <Dropdown overlay={overlayMenu} trigger={['click']}>
            <Button
                icon={
                    <SortAscendingOutlined
                        style={{
                            color: runwayColors.primary,
                        }}
                    />
                }
            >
                Sort: {selectedSortOption.text}
            </Button>
        </Dropdown>
    );
}
